

























import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Location } from "vue-router";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class HeaderMenuMobile extends Vue {
  @Prop({ required: true }) public entries: Location[];
  @Inject("normalizeName") public normalizeName: (name: string) => string;

  private nightMode: boolean;
}
